import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reportFill" }
const _hoisted_2 = { style: {"max-width":"100%","height":"500px"} }
const _hoisted_3 = { style: {"margin-top":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div id=\"overlay\" style=\"position:fixed;top:0;left:0;width:100%;height:100%;display:none;background-color:rgba(0, 0, 0, 0.5);z-index:9999;\"></div><div id=\"loading\" style=\"position:fixed;top:50%;left:50%;display:none;transform:translate(-50%, -50%);background-color:#fff;padding:20px;border-radius:5px;z-index:10000;align-items:center;justify-content:center;flex-direction:column;\"><img src=\"https://jstd-auxi.oss-cn-hangzhou.aliyuncs.com/auxi/2023-07-09/loading.gif\" style=\"width:40%;height:40%;\" alt=\"Loading-Box\"><span style=\"margin-top:20px;\">努力上传中，请耐心等待...</span><span style=\"margin-top:10px;font-size:12px;color:gray;\">Tip:视频尺寸推荐 宽度:690 高度:auto</span></div>", 2)

import "@wangeditor/editor/dist/css/style.css"
import {onBeforeUnmount, ref, shallowRef} from "vue"
import {Editor, Toolbar} from "@wangeditor/editor-for-vue"
import {ElMessage} from "element-plus"
import type {IEditorConfig, IToolbarConfig} from "@wangeditor/core"
import {useRoute, useRouter} from 'vue-router'
import {editPageData, getListData} from "@/service/main/system";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'WangEditor',
  props: {
  textHtml: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props

const confirmLoading = ref(false)
var getValue: string
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();
const router = useRouter()  //进行跳转使用（Router）
const route = useRoute()  //调用传递过来的数据（RouteLocationNormalizedLoaded）

// 工具栏配置
const toolbarConfig: Partial<IToolbarConfig> = {
  excludeKeys: [ //隐藏不用的功能
    "fullScreen",       //全屏
    "blockquote",       //引用
    "group-more-style", //删除线、行内代码、上标、下标、清除格式
    "bulletedList",     //无序
    "numberedList",     //有序
    "lineHeight",       //行高
    "todo",             //待办
    "group-indent",     //缩进
    "insertTable",      //表格
    "codeBlock",        //代码块
    "divider"           //分割线
  ],
}

// 编辑器配置
const editorConfig: Partial<IEditorConfig> = {
  // 最长输入10000字
  maxLength: 10000,
  // 进入页面自动聚焦
  autoFocus: true,
  placeholder: '请输入内容...',
  MENU_CONF: {
    "uploadImage": { //上传图片
      async customUpload(file: any, insertFn: any) {
        await upLoadImgVideo(file, insertFn);
      }
    },

    "uploadVideo": { //上传视频
      async customUpload(file: any, insertFn: any) {
        await upLoadImgVideo(file, insertFn);
      }
    }
  }
}

// 封装 - 上传图片、视频
const upLoadImgVideo = async (file: any, insertFn: any) => {
  if (file.size / 1024 / 1024 > 500) {
    ElMessage.error(`文件大小不能超过500MB!`)
    return false
  } else {
    showLoading()
    let data = await getListData('/oss/policy', {})
    let type = file.name.split(".")[1]
    let randomNumber = Math.floor(Math.random() * (9999999999999 - 1000000000000 + 1) + 1000000000000);
    let key = data.dir + randomNumber + "." + type
    let formData = new FormData()
    formData.append('accessId', data.accessId)
    formData.append('policy', data.policy)
    formData.append('signature', data.signature)
    formData.append('expire', data.expire)
    formData.append('dir', data.dir)
    formData.append('OSSAccessKeyId', data.accessId)
    formData.append('host', data.host)
    formData.append('key', key)
    formData.append("file", file)
    let fileUrl = data.host
    let config = {
      headers: {"Content-Type": "multipart/form-data"}
    }
    axios.post(fileUrl, formData, config).then(res => {
      if (res.status == 200 || res.status == 204) {
        if (key.includes('.mp4')) {
          insertFn(data.host + "/" + key, data.host + "/" + key + "?x-oss-process=video/snapshot,t_1000,m_fast")
        } else {
          insertFn(data.host + "/" + key)
        }
        hideLoading()
      } else {
        alert("上传文件失败")
      }
    })
  }
}

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
})

const handleCreated = async (editor: any) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
  let rtContent = await getListData('/main/promotionMaterial/getRtContentByUrl', {
    url: route.query['materialUrl'],
    id: route.query['materialId']
  })
  editor.setHtml(rtContent)
}

// 获得输入的内容
const handleChange = (editor: any) => {
  getValue = editor.getHtml()
}

// 提交按钮点击事件
const handleSubmitClick = async () => {
  confirmLoading.value = true
  const queryParam = {
    id: route.query['materialId'],
    rtContent: getValue
  }
  try {
    let result = await editPageData('/main/promotionMaterial/updateRtContent', queryParam);
    if (result == '修改成功') {
      router.back()
    }
  } finally {
    confirmLoading.value = false
  }
}

// 取消按钮点击事件
const handleCancelClick = () => {
  router.back()
}

// 显示遮罩和加载框
function showLoading() {
  document.getElementById('loading').style.display = 'flex';
  document.getElementById('overlay').style.display = 'block'
}

// 隐藏加载框
function hideLoading() {
  document.getElementById('loading').style.display = 'none';
  document.getElementById('overlay').style.display = 'none'
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Toolbar), {
          style: {"border-bottom":"1px solid #ccc"},
          editor: editorRef.value,
          defaultConfig: toolbarConfig,
          mode: 'default'
        }, null, 8, ["editor"]),
        _createVNode(_unref(Editor), {
          style: {"height":"700px","overflow-y":"hidden"},
          modelValue: props.textHtml,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.textHtml) = $event)),
          defaultConfig: editorConfig,
          mode: 'default',
          onOnCreated: handleCreated,
          onOnChange: handleChange
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: handleCancelClick }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSubmitClick,
            loading: confirmLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _hoisted_4
  ], 64))
}
}

})